import styles from "./App.module.css";
import { useMemo, useState, useEffect } from "react";
import { Chat } from "./components/Chat/Chat";
import Sidebar from "./components/sidebar/sidebar";
import { v4 as uuidv4 } from "uuid";
import { Assistant } from "./assistants/googleai";


function App() {  
  const [assistant, setAssistant] = useState();
  const [chats, setChats] = useState([]);
  const [activeChatId, setActiveChatId] = useState();
  const activeChatMessages = useMemo(
    () => chats.find(({ id }) => id === activeChatId)?.messages ?? [],
    [chats, activeChatId]
  );

  useEffect(() => {
    setAssistant(new Assistant());
  }, []);


  function handleChatMessagesUpdate(id, messages) {
    const title = messages[0]?.content.split(" ").slice(0, 7).join(" ");
    
    setChats((prevChats) =>
      prevChats.map((chat) =>
        chat.id === activeChatId
          ? { ...chat, title: chat.title ?? title, messages }
          : chat
      )
    );
  }

  useEffect(() =>{
    handleNewChatCreate();
  }, [])

  function handleNewChatCreate() {
    const id = uuidv4();
    setActiveChatId(id);
    setChats((prevChats) => [
      ...prevChats,
      { id, messages: [] },
    ]);
  }

  function handleActiveChatIdChange(id) {
    setActiveChatId(id);
    setChats((prevChats) =>
      prevChats.filter(({ messages }) => messages.length > 0)
    );
  }
  return (
    <div className={styles.App}>
      <header className={styles.header}>
        <img src="/robot.png" alt="ugyf" className={styles.logo} />

        <h2 className={styles.title}>AI Chatbot</h2>
      </header>
      <div className={styles.content}>
        <Sidebar
          chats={chats}
          activeChatId={activeChatId}
          onActiveChatIdChange={handleActiveChatIdChange}
          onNewChatCreate={handleNewChatCreate}
          activeChatMessages={activeChatMessages}
          on
        />

        <main className={styles.main}>
          {chats
          .map((chat) => (
            <Chat
            key={chat.id}
            isActive={chat.id === activeChatId}
            onChatMessagesUpdate={handleChatMessagesUpdate}
            assistant={assistant}
            chatId={chat.id}
            chatMessages={chat.messages}
          />
          ))}
          
        </main>
      </div>
    </div>
  );
}
export default App;
